/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { IIndependentVarProps } from '../Model';
import { Checkbox } from '@scuf/common';

import './CheckboxVariable.scss';

export const CheckboxIndependentVar: React.FC<IIndependentVarProps<null>> = (
  props: IIndependentVarProps<null>
) => {
  return (
    <div className="common-input-wrapper indep-var-checkbox-wrapper">
      <Checkbox
        label={props.displayName}
        checked={props.checked}
        onChange={props.onCheckBoxChange}
        disabled={props.disabled}
      />
    </div>
  );
};
